/* eslint-disable new-cap */
import Vue from 'vue';
import Axios from 'axios';
import { Loading, Message } from 'element-ui';
import nprogress from '@/utils/nprogress';
import { delCookie, getCookie } from '@/utils/cookie';
import { getSubdomain, getToken } from '@/utils/auth';
import JSON_BIG from 'json-bigint';
import Cookies from 'js-cookie';
import { errorReport } from './data';

const _ = require('lodash');

export const baseURL = '';

let needLoadingRequestCount = 0;
// 获取全局配置的baseUrl
const getBaseUrl = () => {
  return window.baseUrl;
};
console.log('getBaseUrl', getBaseUrl());
// let loading;

/*开启遮罩*/
// function startLoading() {
//   loading = Loading.service({
//     customClass: 'axios-loading',
//     lock: true,
//     spinner: 'el-icon-loading',
//     background: 'rgba(0, 0, 0, 0.5)',
//   });
// }

/*关闭遮罩*/
// function endLoading() {
//   if (loading) {
//     loading.close();
//   }
// }

function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    nprogress.start();
    // _.debounce(startLoading, 301)();
  }
  needLoadingRequestCount++;
}

function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  nprogress.done();
  //   if (needLoadingRequestCount === 0) {
  //     _.debounce(endLoading, 300)();
  //   }
}
// 创建axios实例
const service = Axios.create({
  baseURL: baseURL,
  timeout: 600000,
  withCredentials: true, // 允许发送包含凭据（如 Cookies）的请求
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE',
    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
  },
  transformResponse: data => {
    try {
      return JSON_BIG.parse(data);
    } catch (err) {
      return JSON.parse(data);
    }
  },
});
service._requestCount = 0; // 累加请求次数
service._requestTimeIdList = [];
service.interceptors.request.use(
  config => {
    // 接口白名单不展示弹窗
    const apiWhiteList = [
      '/rest/homeV2',
      '/rest/home/company/list',
      '/rest/waybill/v2/count/byStatus',
      '/rest/waybill/v2/pageList',
    ];
    if (!apiWhiteList.includes(config.url)) {
      showFullScreenLoading();
    }

    if (config.url.includes('shipper/api')) {
      config.headers['x-access-token'] = getToken();
      if (!window.location.href.includes('localhost')) {
        config.url = getBaseUrl().SHIPPERS + config.url.replace('shipper/', '');
      }
    }
    if (config.url.includes('api/ai-saas')) {
      config.headers['x-access-token'] = getToken();
      if (!window.location.href.includes('localhost')) {
        config.url = getBaseUrl().AISASS + config.url.replace('api/ai-saas/', 'api/ai/');
      }
    }
    if (localStorage.getItem('visitorId')) {
      config.headers['Fingerprint'] = localStorage.getItem('visitorId');
    }
    const ShippersUserInfo = getCookie('ShippersUserInfo')
      ? JSON.parse(getCookie('ShippersUserInfo'))
      : {};
    if (ShippersUserInfo && ShippersUserInfo.accessToken) {
      config.headers['unified-token'] = ShippersUserInfo.accessToken;
    } else {
      const unifiedToken = getCookie('oss-token') ? getCookie('oss-token') : '';
      if (unifiedToken && config.url.includes('ads/query')) {
        config.headers['unified-token'] = unifiedToken;
      }
    }
    config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    config.headers['Access-Control-Allow-Origin'] = '*';
    config.headers.common['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE'; // 允许的HTTP方法
    config.headers.common['Access-Control-Allow-Headers'] =
      'Origin, X-Requested-With, Content-Type, Accept'; // 允许的请求头
    // 标记API请求源 一站式：ONE_STOP_WEB、调度端：ONE_STOP_WX_DISPATCH、司机端：ONE_STOP_WX_DRIVER、财务端：ONE_STOP_WX_CASHIER、运营端：ONE_STOP_ADMIN_OPERATIONS
    config.headers['Request-Source'] = 'ONE_STOP_WEB';
    const cookie = getCookie('oss-token') ? getCookie('oss-token') : '';
    const mobile = window.localStorage.userInfo
      ? JSON.parse(window.localStorage.userInfo).mobile &&
        JSON.parse(window.localStorage.userInfo).mobile
      : '';
    const arr = [
      '18037935287',
      '18701541384',
      '17600577408',
      '18516890722',
      '15701303002',
      '18600006505',
      '18701025167',
      '18518768403',
      '15110053877',
      '18610186956',
      '15546403751',
      '18515393902',
      '18600630394',
      '13691591913',
    ];
    // 白名单账号不能登陆 pre 环境
    if (
      !config.url.includes('employeeUser/refresh') &&
      cookie &&
      window.location.host.split('.')[0] === '2pre' &&
      !arr.includes(mobile)
    ) {
      const url = window.location.href.replace('2pre', '2');
      window.location.href = url;
    }
    return config;
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  },
);

// 添加响应拦截器
service.interceptors.response.use(
  res => {
    tryHideFullScreenLoading();
    const { data } = res;
    if (data.code != 200 && data.code != '00000') {
      // 如果配置了 customErrorHandler，则不显示全局错误提示，直接返回数据让组件自己处理
      if (res?.config?.customErrorHandler) {
        return data;
      } else {
        errorReport(res);
      }
    }
    // 白名单code 不进行拦截处理（支持数字和字符串格式）
    const allowCodes = [200, 502, 503, 5001, 5002, '00000'];
    if (allowCodes.includes(data.code)) {
      return data;
    } else if (data.code === 403 || data.code === 401) {
      Message({
        message: data.message,
        showClose: true,
        type: 'error',
        duration: 1 * 1000,
      });
      setTimeout(() => {
        window.localStorage.clear();

        // delCookie('oss-token',`nucarf.${ window.location.hostname.split('.')[window.location.hostname.split('.').length - 1] }`,'/',);
        // delCookie('unified-token',`nucarf.${ window.location.hostname.split('.')[window.location.hostname.split('.').length - 1] }`,'/',);
        const subdomain = getSubdomain(window.location.hostname);
        console.log('403', subdomain);
        Cookies.remove('oss-token', { domain: subdomain });
        Cookies.remove('unified-token', { domain: subdomain });
        Cookies.remove('satoken', { domain: subdomain });
        Cookies.remove('ShippersUserInfo', { domain: subdomain });
        // window.location.href = '/login';
      }, 100);
    } else if (data.code === 404) {
      window.location.href = '/404';
    } else {
      Message.closeAll();
      Message({
        message: `${
          data.msg ? data.msg : data.message ? data.message : ''
        }<a id="ErrorMsg" style="color: #2650ff;cursor: pointer;">点击上报</a>`,
        showClose: true,
        dangerouslyUseHTMLString: true,
        type: 'error',
        duration: 3 * 1000,
      });
      document.getElementById('ErrorMsg').addEventListener('click', e => {
        e.currentTarget.style.color = '#f36807';
      });
      return '';
    }
  },
  err => {
    // 对响应错误做点什么
    tryHideFullScreenLoading();
    // errorReport(err);
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = '请求错误';
          break;

        case 401:
          err.message = '未授权，请登录';
          break;

        case 403:
          err.message = '拒绝访问';
          break;

        case 404:
          err.message = `请求地址出错: ${err.response.config.url}`;
          break;

        case 408:
          err.message = '请求超时';
          break;

        case 501:
          err.message = '服务未实现';
          break;

        case 502:
          err.message = '系统正在更新，请稍后再试～';
          break;

        case 503:
          err.message = '系统维护中，请稍后再试';
          break;

        case 504:
          err.message = '网关超时';
          break;

        case 505:
          err.message = 'HTTP版本不受支持';
          break;

        default:
          err.message = err.msg ? err.msg : err.message;
          break;
      }
    } else {
      err.message = '连接服务器失败!';
      return;
    }
    Message.closeAll();
    Message({
      message: `${err.message}<a id="ErrorMsg" style="color: #2650ff;cursor: pointer;">点击上报</a>`,
      showClose: true,
      dangerouslyUseHTMLString: true,
      type: 'error',
      duration: 3 * 1000,
    });
    // 对响应错误做点什么
    document.getElementById('ErrorMsg').addEventListener('click', e => {
      e.currentTarget.style.color = '#f36807';
    });

    return Promise.reject(err);
  },
);

Vue.prototype.$http = service;

export default service;
